
import { cn } from "@/lib/utils";
import AnimatedCard from "../AnimatedCard";
import { ArrowRight } from "lucide-react";

interface ServiceCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  color: string;
  isActive?: boolean;
  onClick?: () => void;
  delay?: number;
}

export const ServiceCard = ({
  title,
  description,
  icon,
  color,
  isActive = false,
  onClick,
  delay = 0
}: ServiceCardProps) => {
  return (
    <AnimatedCard delay={delay} animation="scale-in">
      <div 
        className={cn(
          "service-card h-full p-6 backdrop-blur-lg bg-white/5 border border-white/10 rounded-2xl transition-all duration-300 hover:bg-white/10 hover:shadow-lg hover:shadow-primary/10 group cursor-pointer",
          isActive ? "bg-white/10 border-white/20" : ""
        )}
        onClick={onClick}
      >
        <div className={cn("p-3 rounded-xl inline-block mb-4", color)}>
          {icon}
        </div>
        <h3 className="text-xl font-semibold mb-3 flex items-center gap-2">
          {title}
          <ArrowRight className="h-4 w-4 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
        </h3>
        <p className="text-white/70">{description}</p>
      </div>
    </AnimatedCard>
  );
};

export default ServiceCard;
